import { render } from "./CarouselFavorites.vue?vue&type=template&id=0af9b2d8"
import script from "./CarouselFavorites.vue?vue&type=script&lang=js"
export * from "./CarouselFavorites.vue?vue&type=script&lang=js"

import "./CarouselFavorites.vue?vue&type=style&index=0&id=0af9b2d8&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__